import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getGroupResponse from '@/types/responses/getGroup';
import { onMounted, ref, watch, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupAutoComplete',
  props: {
    modelValue: {},
    managementOffice: {},
    operationOffices: {},
    type: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedItem = ref<getGroupResponse | undefined>(undefined);
const filteredItems = ref<getGroupResponse[]>([]);
const items = ref<getGroupResponse[]>([]);

onMounted(() => {
  Api()
    .autoCompleteGroups(makeQueryParams())
    .then((data) => {
      items.value = data;
      setFilterItems(data);
    });
});

function makeQueryParams() {
  return {
    status: 1
  };
}

const setFilterItems = (data: getGroupResponse[]) => {
  if (props.type === undefined) {
    filteredItems.value = data;
  } else {
    filteredItems.value = data.filter((item) => item.type === props.type);
  }
};

watch(
  () => props.type,
  () => {
    setFilterItems(items.value);
  }
);

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: "グループ",
    itemName: "name",
    items: filteredItems.value,
    "management-office": __props.managementOffice,
    "operation-offices": __props.operationOffices,
    "error-messages": __props.errorMessages
  }, null, 8, ["modelValue", "items", "management-office", "operation-offices", "error-messages"]))
}
}

})